<template>
  <v-row dense justify="center">
    <v-col cols="12">
      <v-form @submit.prevent="submit()" v-model="form.valid" lazy-validation method="post" ref="form">
        <!-- Telefone -->
        <template v-if="!user.person.phones.length">
          <p>Dados de contato</p>
          <v-text-field
            name="number"
            label="Telefone"
            v-model="payload.phone_number"
            required
            v-mask="'(##) # ####-####'"
            type="text"
            :error-messages="error.messages.phone_number"/>
        </template>
        <!-- Endereço -->
        <template v-if="!user.person.addresses.length">
          <p>Dados de endereço</p>
          <v-select
            :items="states"
            name="state"
            label="Estado"
            v-model="payload.address_state_id"
            required
            type="text"
            :error-messages="error.messages.address_state_id"/>
          <v-select
            :items="cities"
            name="city"
            label="Cidade"
            v-model="payload.address_city_id"
            required
            type="text"
            :error-messages="error.messages.address_city_id"/>
          <v-text-field
            name="street"
            label="Rua/Avenida"
            v-model="payload.address_street"
            required
            type="text"
            :error-messages="error.messages.address_street"/>
          <v-text-field
            name="neighborhood"
            label="Bairro"
            v-model="payload.address_neighborhood"
            required
            type="text"
            :error-messages="error.messages.address_neighborhood"/>
          <v-text-field
            name="cep"
            label="CEP"
            v-model="payload.address_cep"
            required
            v-mask="'#####-###'"
            type="text"
            :error-messages="error.messages.address_cep"/>
          <v-text-field
            name="number"
            label="Número"
            v-model="payload.address_number"
            type="numeric"
            :error-messages="error.messages.address_number"/>
          <v-text-field
            name="complement"
            label="Complemento"
            v-model="payload.address_complement"
            type="numeric"
            :error-messages="error.messages.address_complement"/>
        </template>
        <!-- Carrinho apenas com cursos gratuitos -->
        <template v-if="payload.type === 'SINGLE_PAYMENT' && cartIsFree">
          <v-row dense>
            <v-col cols="12">
              <v-alert :value="true" dark color="info" icon="mdi-check-circle" outlined>
                Você selecionou apenas cursos gratuitos, não há cobranças.
              </v-alert>
            </v-col>
          </v-row>
        </template>
        <!-- Carrinho com Pagamento único ou Assinaturas -->
        <template v-else>
          <v-row dense>
            <v-col cols="12">
              <v-item-group v-model="payload.payment_method">
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-item value="BOLETO" v-slot:default="{ active, toggle }">
                      <v-card flat :color="active ? 'primary' : 'grey darken-2'" dark @click="toggle">
                        <v-card-text class="text-center title" style="cursor: pointer">
                          Boleto
                        </v-card-text>
                      </v-card>
                    </v-item>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-item value="CREDIT_CARD" v-slot:default="{ active, toggle }">
                      <v-card flat :color="active ? 'primary' : 'grey darken-2'" dark @click="toggle">
                        <v-card-text class="text-center title" style="cursor: pointer">
                          Cartão de Crédito
                        </v-card-text>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-item-group>
            </v-col>
          </v-row>
          <template v-if="payload.payment_method === 'BOLETO'">
            <v-row dense>
              <v-col cols="12" class="text-center py-3">
                <v-alert :value="true" dark color="info" icon="mdi-check-circle" outlined>
                  Você está optando por pagamento via boleto
                </v-alert>
              </v-col>
              <v-col cols="12" v-if="payload.type === 'PLAN'">
                <v-item-group v-model="payload.installments">
                  <v-subheader>Quantidade de parcelas</v-subheader>
                  <v-item v-for="installment in installments" :key="installment.value" :value="installment.value" v-slot:default="{ active, toggle }">
                    <v-chip class="ml-3 mb-3" active-class="primary--text" :input-value="active" @click="toggle">
                      {{ installment.text }}
                    </v-chip>
                  </v-item>
                </v-item-group>
              </v-col>
            </v-row>
          </template>
          <template v-if="payload.payment_method === 'CREDIT_CARD'">
            <v-row dense>
              <v-col cols="12">
                Dados de pagamento
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  name="holder_name"
                  label="Nome do Titular"
                  v-model="payload.card_holder_name"
                  required
                  type="text"
                  :error-messages="error.messages.card_holder_name"
                  autofocus/>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  name="number"
                  label="Número do Cartão"
                  v-model="payload.card_number"
                  required
                  type="number"
                  :error-messages="error.messages.card_number"/>
              </v-col>
              <v-col cols="6" md="4">
                <v-text-field
                  name="expiration_date"
                  label="Data de expiração"
                  v-model="payload.card_expiration_date"
                  required
                  type="text"
                  v-mask="'##/##'"
                  :error-messages="error.messages.card_expiration_date"/>
              </v-col>
              <v-col cols="6" md="4">
                <v-text-field
                  name="cvv"
                  label="CVV"
                  v-model="payload.card_cvv"
                  required
                  type="number"
                  :error-messages="error.messages.card_cvv"/>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  :items="installments"
                  name="installments"
                  label="Parcelas"
                  v-model="payload.installments"
                  required
                  type="text"
                  :error-messages="error.messages.installments"/>
              </v-col>
            </v-row>
          </template>
        </template>
        <!-- Submit -->
        <template v-if="payload.payment_method">
          <v-btn type="submit" class="mt-3" large depressed dark block color="green">
            Finalizar Compra
          </v-btn>
        </template>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import store from '@/store'
import { State } from '@/services/resources'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    type: String,
    items: Array,
    item: Object
  },
  mounted () {
    State.get().then((response) => {
      this.states = response.body.map((item) => {
        return { text: item.name, value: item.id }
      })
    })
    /**
     * Insere otipo do pacote de curso
     */
    this.payload.type = this.type
    if (this.type === 'SINGLE_PAYMENT') {
      /**
       * Insere os IDs dos pacotes de curso
       */
      this.payload.course_packages = this.items.map(item => item.id)
      /**
       * Recupera os metodos de pagamento disponíveis dentre os cursos do carrinho
       */
      this.payment_methods = this.items.reduce((accumulator, current) => {
        /**
         * Considera apenas cursos não gratuitos
         */
        if (current.type === 'SINGLE_PAYMENT') {
          return accumulator.concat(current.payment_methods)
        }
        return accumulator
      }, [])
      /**
       * Recupera o maior numero de parcelas dentre os cursos do carrinho
       */
      const installments = this.items.reduce((accumulator, current) => {
        /**
         * Considera apenas cursos não gatuitos
         */
        if (current.type === 'SINGLE_PAYMENT') {
          return accumulator < current.single_payment.installments ? current.single_payment.installments : accumulator
        }
        return accumulator
      }, 1)
      /**
       * Gera os dados de parcelamento do campo select
       */
      for (let i = 1; i <= installments; i++) {
        this.installments.push({ text: `${i}x`, value: i })
      }
    } else if (this.type === 'PLAN') {
      /**
       * Insere o ID do pacote de curso
       */
      this.payload.course_packages.push(this.item.id)
      /**
       * Insere os metodos de pagamento aceito pelo pacote de curso
       */
      this.payment_methods = this.item.payment_methods
      /**
       * Gera os dados de parcelamento do campo select
       */
      for (let i = 1; i <= this.item.plan.installments; i++) {
        this.installments.push({ text: `${i}x`, value: i })
      }
    }
  },
  watch: {
    'payload.address_state_id' (val) {
      State.cities(val).then((response) => {
        this.cities = response.body.map((item) => {
          return { text: item.name, value: item.id }
        })
      })
    }
  },
  data () {
    return {
      create_address: true,
      create_phone: true,
      states: [],
      cities: [],
      payment_methods: [],
      installments: [],
      payload: {
        type: '',
        course_packages: [],
        payment_method: '',
        phone_id: '',
        phone_number: '',
        address_id: '',
        address_street: '',
        address_neighborhood: '',
        address_number: '',
        address_complement: '',
        address_city_id: '',
        address_cep: '',
        card_holder_name: '',
        card_number: '',
        card_expiration_date: '',
        card_cvv: '',
        installments: 1
      },
      error: {
        error: false,
        messages: {}
      },
      form: {
        valid: false
      }
    }
  },
  methods: {
    ...mapActions({
      clearCart: 'Cart/clearCart'
    }),
    submit () {
      this.payload.address_cep = this.payload.address_cep.replace(/\D+/g, '')
      this.payload.card_expiration_date = this.payload.card_expiration_date.replace(/\D+/g, '')

      if (!this.cartIsFree && !this.payload.payment_method) {
        this.$toasted.error('Selecione um método de pagamento!')
        return
      }
      if (!this.cartIsFree && !this.payload.installments) {
        this.$toasted.error('Escolha o número de parcelas!')
        return
      }
      this.error.error = false
      this.error.messages = []
      if (this.$refs.form.validate()) {
        store.dispatch('App/order', this.payload)
          .then((response) => {
            this.clear()
            this.clearCart()
            this.$router.push({ name: 'ambienteAluno.dashboard' })
          })
          .catch((responseError) => {
            if (responseError.status === 422) {
              console.log(responseError.data.errors)
              this.error.messages = responseError.data.errors
              this.form.valid = false
            } else {
              this.$toasted.error(responseError.data.message)
            }
          })
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'App/isAuthenticated',
      user: 'App/user',
      cartIsFree: 'Cart/getCartIsFree'
    })
  }
}
</script>
